export default function shouldResetToDefaultValue(defaultField, currentField, nextField) {
  const isInvisible = currentField.visible && !nextField.visible;
  const isReadOnly = !currentField.readOnly && nextField.readOnly;
  return isInvisible || isReadOnly;
}